<template>
  <div class="access-instructions-config-generation">
    <el-card>
      <template #header>
        <div class="card-header">
          <el-icon><Key /></el-icon>
          <span>配置生成</span>
        </div>
      </template>
      <div class="card-content">
        <p><strong>生成 accessKey</strong></p>
        <p>选择<router-link to="/dashboard" target="_blank">控制台</router-link>，在通行密钥卡片中点击“生成”按钮，即可生成 accessKey 值。需注意：accessKey 一旦生成后无法再次生成，该值不会过期且无需在请求时配置。</p>

        <p><strong>设置 Object 密钥</strong></p>
        <p>在Object密钥卡片中点击“管理”按钮，在弹窗中填写 Object 密钥值。需注意：ObjectKey 修改后立即生效，请在使用前保证该值的准确性。</p>

        <p><strong>生成临时密钥</strong></p>
        <!-- 修改部分：将“临时密钥”改为可点击的链接 -->
        <p>选择<router-link to="/temporary-keys" target="_blank">临时密钥</router-link>，点击“新增”按钮，即可生成一组临时密钥值。需注意：一个用户最多只能设置 2 组临时密钥，一般情况下建议用户使用其中一组，如怀疑临时密钥出现被他人使用的情况，可生成另外一组供业务替换后再把原数据删除，保证业务顺利切换。</p>

        <p><strong>用户业务系统配置（以 yml 配置为例）</strong></p>
        <pre><code class="yaml">
fos_client:
  objectKey: xxxx/yyyy
  server_url: URL
  tmp_token: ${你自己的临时密钥}
  secret_key: ${你自己的临时密码}
        </code></pre>
      </div>
      <!-- 修改底部链接部分 -->
      <div class="access-instructions-footer">
        <!-- 修改链接顺序，将概述概要移到左侧 -->
        <router-link to="/access-instructions/overview" class="next-document-link">
          <el-icon><ArrowLeft /></el-icon> 概述概要
        </router-link>
        <router-link to="/access-instructions/get-access-key" class="next-document-link">
          获取通行密钥 <el-icon><ArrowRight /></el-icon>
        </router-link>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { Key, ArrowRight, ArrowLeft } from '@element-plus/icons-vue' // 引入 ArrowLeft 图标
// 引入公共样式
import '@/styles/common-access-instructions.css'
</script>

<style scoped>
.access-instructions-config-generation {
  padding: 20px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
}

.card-content {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.card-content p {
  margin-bottom: 10px;
}

.card-content pre {
  background-color: #f4f4f4;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}

.card-content code {
  font-family: 'Courier New', Courier, monospace;
}

.access-instructions-footer {
  display: flex;
  justify-content: space-between; /* 使链接分布在左右两侧 */
}

.next-document-link {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>